module.exports = __webpack_public_path__ + "static/media/recently-viewed-empty-state.c180f6f7.svg";